import React__default from 'react';
import { isServerSide } from '../isServerSide.js';

/**
 * Isomorphic React effect hook works on the both client and server.
 *
 * Motivation:
 * There are cases where React hook `useLayoutEffect` makes more sense if we
 * want to perform DOM operations synchronously before browser paint.
 * However, React warns when used this hook with SSR components. Hence,
 * suppressing the warning by switching the hook between SSR and CSR.
 *
 */

var useIsomorphicLayoutEffect = isServerSide() ? React__default.useEffect : React__default.useLayoutEffect;

export { useIsomorphicLayoutEffect };
